const comparisonData = [
  { feature: 'Free tier MAU', jumpstone: '1,000', others: '500-1,000' },
  { feature: 'SSO included', jumpstone: 'All plans', others: 'Enterprise only' },
  { feature: 'Multi-tenant', jumpstone: 'Built-in', others: 'Add-on' },
  { feature: 'Custom domains', jumpstone: 'All plans', others: 'Paid plans' },
  { feature: 'User management UI', jumpstone: 'Included', others: 'Extra cost' },
  { feature: 'SOC 2 certified', jumpstone: 'Type II', others: 'Varies' },
]

export function Comparison() {
  return (
    <section className="py-24 bg-surface-900/50">
      <div className="mx-auto max-w-7xl section-padding">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Why developers choose JumpstoneAuth
          </h2>
          <p className="text-lg text-surface-400">
            We built the auth platform we wished existed. More features, better pricing, and a developer experience that doesn't suck.
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="card overflow-hidden">
            <div className="grid grid-cols-3 bg-surface-800/50 border-b border-surface-700">
              <div className="p-4 text-sm font-medium text-surface-400">Feature</div>
              <div className="p-4 text-sm font-medium text-brand-400 text-center">JumpstoneAuth</div>
              <div className="p-4 text-sm font-medium text-surface-500 text-center">Others</div>
            </div>
            {comparisonData.map((row, index) => (
              <div
                key={row.feature}
                className={`grid grid-cols-3 ${index !== comparisonData.length - 1 ? 'border-b border-surface-800' : ''}`}
              >
                <div className="p-4 text-sm text-surface-300">{row.feature}</div>
                <div className="p-4 text-sm text-white text-center font-medium">{row.jumpstone}</div>
                <div className="p-4 text-sm text-surface-500 text-center">{row.others}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Stats */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="text-center">
            <div className="text-4xl font-bold text-white mb-2">99.99%</div>
            <div className="text-sm text-surface-500">Uptime SLA</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-white mb-2">&lt;50ms</div>
            <div className="text-sm text-surface-500">Global latency</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-white mb-2">10M+</div>
            <div className="text-sm text-surface-500">Authentications/mo</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-white mb-2">2,000+</div>
            <div className="text-sm text-surface-500">Teams trust us</div>
          </div>
        </div>
      </div>
    </section>
  )
}

